var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 55,
    viewBox: "0 0 60 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 55,
    rx: 10,
    fill: "#F7F7F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3038 13C13.5837 13 13 13.584 13 14.3043C13 15.0247 13.5837 15.6087 14.3038 15.6087H16.6236C16.8134 15.6087 16.9984 15.6685 17.1524 15.7795C17.3064 15.8905 17.4216 16.0472 17.4816 16.2274L21.7802 29.1311C21.9711 29.704 21.9953 30.3209 21.8489 30.9068L21.495 32.3257C20.9756 34.4041 22.5927 36.4783 24.7341 36.4783H40.3795C41.0996 36.4783 41.6833 35.8943 41.6833 35.1739C41.6833 34.4535 41.0996 33.8696 40.3795 33.8696H24.7341C24.2264 33.8696 23.9005 33.4528 24.0236 32.9601L24.2905 31.8935C24.3358 31.7128 24.4401 31.5524 24.5869 31.4378C24.7337 31.3231 24.9145 31.2609 25.1008 31.2609H39.0757C39.6371 31.2612 40.1356 30.902 40.3133 30.3692L43.7892 19.9344C44.0708 19.0895 43.4419 18.217 42.5516 18.2174H21.5459C21.3561 18.2174 21.1711 18.1576 21.0171 18.0466C20.8631 17.9356 20.7479 17.7789 20.6879 17.5987L19.4527 13.8916C19.2751 13.3589 18.7765 12.9997 18.2151 13H14.3038ZM23.4303 37.7826C21.9902 37.7826 20.8227 38.9506 20.8227 40.3913C20.8227 41.832 21.9902 43 23.4303 43C24.8704 43 26.0379 41.832 26.0379 40.3913C26.0379 38.9506 24.8704 37.7826 23.4303 37.7826ZM39.0757 37.7826C37.6356 37.7826 36.4681 38.9506 36.4681 40.3913C36.4681 41.832 37.6356 43 39.0757 43C40.5158 43 41.6833 41.832 41.6833 40.3913C41.6833 38.9506 40.5158 37.7826 39.0757 37.7826Z",
    fill: "#DDDDDD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoImage);
export default __webpack_public_path__ + "static/media/no-image.e27ee0bcd4ae1d0fe7013feac417dc88.svg";
export { ForwardRef as ReactComponent };